import React from 'react';
import { connect } from 'react-redux';

import PatternGalleries from './PatternGalleries';
import { getGalleryData } from '../../reducers/patterns';
import { getCategoryTitle } from '../../reducers/categories';
import { sortNumberDesc } from '../../helper/utils';

const CategoryPatterns = props => (
    <PatternGalleries {...props} />
);

const makeMapStateToProps = initialState => {
    const title = getCategoryTitle(initialState);
    return state => {
        const { patterns, items } = getGalleryData(state);
        const sorted = items.sort(sortNumberDesc);
        return {
            title,
            patterns,
            items: sorted,
            totalHits: 100,
        };
    };
};

export default connect(makeMapStateToProps)(CategoryPatterns);



// WEBPACK FOOTER //
// ./src/components/patterngalleries/CategoryPatterns.js